import styled from 'styled-components';
import { colors } from 'theme';

export const StyledGroupDiv = styled.div`
  background-color: ${colors.greyInput};
  padding: 1em;
`;
